<div class="mt-1 row">
    <div class="col-12 align-items-center justify-content-start">
        <div class="mb-0 d-flex align-items-center">
            <span class="game-text">
                {{getLocalizationString("Qualifier", "Qualifier")}}:&nbsp;
            </span>
            <div *ngIf="gameStatus !== 'Upcoming'" class="d-flex align-items-center mr-1">
                <svg class="icon-16 fill-valyrianSteel qualifier-icon"
                    *ngIf="gs.isQualified(ranking?.gameRewards?.MyRankingObj?.MetricGroupInfos[ranking?.gameRewards?.MyRankingObj?.MetricGroupInfos?.length - 1]?.MyMetricValue, game, ranking)">
                    <use href="../../../App_Themes/CXone/icons/gamification/games/check.svg#check"></use>
                </svg>
                <svg class="icon-16 fill-valyrianSteel qualifier-icon"
                    *ngIf="!gs.isQualified(ranking?.gameRewards?.MyRankingObj?.MetricGroupInfos[ranking?.gameRewards?.MyRankingObj?.MetricGroupInfos?.length - 1]?.MyMetricValue, game, ranking)">
                    <use href="../../../App_Themes/CXone/icons/gamification/games/fail.svg#fail"></use>
                </svg>
            </div>
            <div class="mr-1 game-text-detail d-flex align-items-center min-width-0">
                <span class="flex-shrink-0"
                    *ngIf="game.QualifierLevels.comparerType === ComparisonType.Between">{{isQualifiedBetweenLabel('left')}}&nbsp;</span>
                <span #qualifierText class="variation-ellipsis flex-grow-0 flex-shrink-1"
                    [tooltip]="checkTextTruncation(game.Qualifier.name, TooltipType.Q2)" placement="top" container="body"
                    containerClass="tooltip-custom-qualifier" (mouseenter)="tooltipQualifier.show()" triggers="manual"
                    #tooltipQualifier="bs-tooltip" (mouseleave)="tooltipQualifier.hide()"
                    (wheel)="tooltipQualifier.hide()">{{game.Qualifier.name}}</span>
                    <span class="flex-shrink-0"
                    *ngIf="game.QualifierLevels.comparerType === ComparisonType.GreaterThan">&nbsp;{{isQualifiedBetweenLabel('right', true)}}</span>
                <span class="flex-shrink-0"
                    *ngIf="game.QualifierLevels.comparerType === ComparisonType.Between || game.QualifierLevels.comparerType === ComparisonType.LessThan">&nbsp;{{isQualifiedBetweenLabel('right')}}</span>
            </div>
        </div>
    </div>
</div>